import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=2f7b2088&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"
import style0 from "./publish.vue?vue&type=style&index=0&id=2f7b2088&prod&lang=scss&scoped=true"
import style1 from "./publish.vue?vue&type=style&index=1&id=2f7b2088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b2088",
  null
  
)

export default component.exports